import type { TraceState } from "@/store/trace/state";
import { makeState } from "@/store/trace/state";
import type { Span, Trace } from "@/models/traces";
import { mergeIntoOriginal } from "@/utils/objectMerging";
import type { MergeOptions } from "@/utils/objectMerging";

/**
 * Update the Filename value of the Trace Vuex module.
 * @param state - Vuex state for the Trace module.
 * @param filename - Updated value to be stored.
 */
export function setFilename(state: TraceState, filename: string): void {
  state.filename = filename || undefined;
}

/**
 * Update the Trace value of the Trace Vuex module.
 * @param state - Vuex state for the Trace module.
 * @param trace - Updated value to be stored.
 */
export function setTrace(state: TraceState, trace: Trace): void {
  state.trace = trace || undefined;
}

/**
 * Update the Spans value of the Trace Vuex module.
 * @param state - Vuex state for the Trace module.
 * @param spans - Updated value to be stored.
 */
export function setSpans(state: TraceState, spans: Array<Span>): void {
  state.spans = spans || undefined;
}

/**
 * Reset the state object to its initial value.
 * @param state - Vuex state for the module.
 * @param options - Key subset modifiers for the reset operation.
 */
export function reset(state: TraceState, options?: MergeOptions): void {
  mergeIntoOriginal(
    state as unknown as Record<string, unknown>,
    makeState() as unknown as Record<string, unknown>,
    options
  );
}
